/**
 * CoLab Vacancy Cards Module
 * Accordion functionality for vacancy cards
 */

export const Vacancies = {

    cards: [],

    /**
     * Initialize
     */
    init: function() {
        var self = this;

        this.cards = document.querySelectorAll('.vacancy-card');

        if (this.cards.length === 0) return;

        this.cards.forEach(function(card) {
            var toggle = card.querySelector('.vacancy-card__toggle');

            if (toggle) {
                toggle.addEventListener('click', function() {
                    self.toggleCard(card);
                });
            }
        });

        // Check URL hash for direct link to vacancy
        this.checkHash();

        console.log('[CoLab.Vacancies] Initialized with', this.cards.length, 'cards');
    },

    /**
     * Toggle card
     */
    toggleCard: function(card) {
        var isExpanded = card.classList.contains('is-expanded');
        var toggle = card.querySelector('.vacancy-card__toggle');

        // Close all other cards (optional - for accordion behavior)
        // this.closeAll();

        if (isExpanded) {
            card.classList.remove('is-expanded');
            toggle.setAttribute('aria-expanded', 'false');
        } else {
            card.classList.add('is-expanded');
            toggle.setAttribute('aria-expanded', 'true');

            // Smooth scroll to card
            setTimeout(function() {
                card.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }, 100);
        }
    },

    /**
     * Close all cards
     */
    closeAll: function() {
        this.cards.forEach(function(card) {
            var toggle = card.querySelector('.vacancy-card__toggle');
            card.classList.remove('is-expanded');
            if (toggle) {
                toggle.setAttribute('aria-expanded', 'false');
            }
        });
    },

    /**
     * Open specific card by ID
     */
    openById: function(id) {
        var card = document.getElementById(id);
        if (card && card.classList.contains('vacancy-card')) {
            this.toggleCard(card);
        }
    },

    /**
     * Check URL hash and open corresponding vacancy
     */
    checkHash: function() {
        var hash = window.location.hash.substring(1);
        if (hash) {
            var card = document.getElementById(hash);
            if (card && card.classList.contains('vacancy-card')) {
                // Small delay for page load
                var self = this;
                setTimeout(function() {
                    card.classList.add('is-expanded');
                    var toggle = card.querySelector('.vacancy-card__toggle');
                    if (toggle) {
                        toggle.setAttribute('aria-expanded', 'true');
                    }
                    card.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }, 300);
            }
        }
    }
};

// Auto-init
document.addEventListener('DOMContentLoaded', function() {
    if (document.querySelector('.vacancy-card')) {
        Vacancies.init();
    }
});
